import * as ng from 'angular';
import * as _ from 'underscore';

import {FilterServiceFactory, FilterService, DataList} from '../../shared';
import {EventsApi, Event} from '.';

export class EventAdminListController {
   static $inject = [
      'eventsApi', 'session', 'filterServiceFactory', 'loader', 'titleService'
   ];

   filter:FilterService;
   model = new DataList<Event>();

   orgIds:number[];
   brandIds:number[];

   constructor(
      private eventsApi:EventsApi,
      private session,
      filterServiceFactory:FilterServiceFactory,
      private loader,
      titleService
   ) {
      titleService.setTitle('Event Search');

      this.filter = filterServiceFactory({
         key: 'admin-events',
         defaults: {
            orderBy: '-startDate',
            limit: 20,
            page: 1
         },
         properties: [
            'search', 'orgId', 'brandId', 'campaignId', 'startDate', 'endDate'
         ],
         callback: (property) => this.refresh()
      });

      this.onOrgsSelected(this.filter.inputs['orgId']);

      this.refresh();
   }

   onOrgsSelected(orgIds:number[]) {
      this.filter.set('orgId', orgIds);

      if (orgIds) {
         this.orgIds = orgIds;
      } else {
         this.orgIds = _.pluck(this.session.getOrgs(), 'id');
      }

      this.onBrandsSelected(this.filter.inputs['brandId']);
   }

   onBrandsSelected(brandIds:number[]) {
      this.filter.set('brandId', brandIds);

      if (brandIds) {
         this.brandIds = brandIds;
      } else {
         this.brandIds = _.pluck(this.session.getBrandsByOrg(this.orgIds), 'id');
      }
   }

   refresh() {
      this.loader.showSpinner();

      this.eventsApi.list(this.filter.inputs).then(data => {
         this.model.setList(data.list, data.total);
      }).finally(() => {
         this.loader.hide();
      });
   }
}

ng.module('e360')
   .controller('EventAdminListController', EventAdminListController);
